query getMasterBatchPosts($input: GetMasterBatchPostsInput!) {
  getMasterBatchPosts(input: $input) {
    companyId
    companyName
    textKind
    hasActiveConnection
    url
    postingBatchId
    socialMediaPosts {
      type
      permalink
      postId
      scheduledAt
      completedAt
      hasFailed
      failureReason
      id
    }
  }
}
